import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

import React from 'react';

import BackComparisonTable from './BackComparisonTable';

import corporateCommunication from '../utils/BackComparisonValues/corporateCommunication.json';
import plataformManagement from '../utils/BackComparisonValues/plataformManagement.json';
import posIntegration from '../utils/BackComparisonValues/posIntegation.json';
import support from '../utils/BackComparisonValues/support.json';

import useWindowDimensions from '../hooks/useWindowDimensions';

const minScreenSize = 700;

function BackComparison() {
  const { width } = useWindowDimensions();
  return (
    <div id="Comparison">
      <div className="container">
        <div id="header">
          <div className="grid header">
            <div className="flex flex-column justify-content-start">
              <h2 className="title">Compare Plans</h2>
            </div>
          </div>
        </div>
        <div className="comparisonContainer">
          <div id="card-container" className="card">
            <div className="flex justify-content-start plan-section back-plans">
              <div className="col-6">
                <div className="pricing-title">
                  <h3>Plans</h3>
                </div>
              </div>
              <div className="col-4 flex align-items-center">
                <div className="content_box flex flex-column justify-content-flex-start shift">
                  <p className="card-title">Starter</p>
                  <div className="price">$50/mo</div>
                  <Button
                    className="btn-white"
                    label="Get a Demo"
                    onClick={() => {
                      window.location.href = `https://www.upshow.tv/get-a-demo/`;
                    }}
                  />
                </div>
                {width >= minScreenSize ? <Divider layout="vertical" /> : null}
              </div>
              <div className="col-4 flex align-items-center">
                <div className="content_box flex flex-column justify-content-flex-start shift">
                  <p className="card-title">{width >= minScreenSize ? 'Integrated' : 'Integ'}</p>
                  <div className="price">Custom</div>
                  <Button
                    className="btn-white"
                    label="Get a Demo"
                    onClick={() => {
                      window.location.href = `https://www.upshow.tv/get-a-demo/`;
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="table-section">
            <div className="datatable-templating-demo">
              <summary>
                <div>
                  <BackComparisonTable data={corporateCommunication.dataCorporate} title={corporateCommunication.title} />
                </div>
              </summary>
              <div id="collapsible" className="collapse">
                <div className="datatable-templating-demo">
                  <div>
                    <BackComparisonTable data={plataformManagement.dataPlataform} title={plataformManagement.title} />
                  </div>
                </div>
                <div className="datatable-templating-demo">
                  <div>
                    <BackComparisonTable data={posIntegration.dataIntegration} title={posIntegration.title} />
                  </div>
                </div>
                <div className="datatable-templating-demo">
                  <div>
                    <BackComparisonTable data={support.dataSupport} title={support.title} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BackComparison;
